export enum EScope {
  READ_ONLY = 'read_only',
  READ_ALL = 'read_all',
  READ_WRITE = 'read_write',
  LEGAL = 'legal',
  SUPPORT_USER_MANAGEMENT = 'support_user_management',
  ADMIN = 'admin',
  KEYS = 'keys',
  ACTION_BENEF = 'sensitive_action_beneficiary',
  ACTION_PAYMENT = 'sensitive_action_payment',
}

export enum ERole {
  SUPPORT_USER_READ_ONLY = 'SUPPORT_USER_READ_ONLY',
  SUPPORT_USER = 'SUPPORT_USER',
  SUPPORT_LEGAL_USER = 'SUPPORT_LEGAL_USER',
  MANAGER = 'MANAGER',
  ADMIN = 'ADMIN',
}

export type TRoleSlugs = keyof typeof ERole;

export type TRoleScopes = Record<ERole, Array<EScope>>;

export const RoleToScopeDictionnary: TRoleScopes = {
  SUPPORT_USER_READ_ONLY: [EScope.READ_ONLY, EScope.READ_ALL],
  SUPPORT_USER: [EScope.READ_ONLY, EScope.READ_ALL, EScope.READ_WRITE],
  SUPPORT_LEGAL_USER: [EScope.READ_ONLY, EScope.READ_ALL, EScope.READ_WRITE, EScope.LEGAL],
  MANAGER: [
    EScope.READ_ONLY,
    EScope.READ_ALL,
    EScope.READ_WRITE,
    EScope.LEGAL,
    EScope.SUPPORT_USER_MANAGEMENT,
    EScope.ACTION_BENEF,
    EScope.ACTION_PAYMENT,
  ],
  ADMIN: [
    EScope.READ_ONLY,
    EScope.READ_ALL,
    EScope.READ_WRITE,
    EScope.LEGAL,
    EScope.SUPPORT_USER_MANAGEMENT,
    EScope.ADMIN,
    EScope.ACTION_BENEF,
    EScope.ACTION_PAYMENT,
  ],
};
